// extracted by mini-css-extract-plugin
export var scrollTrack = "HorizontalScrollSection-module--scrollTrack--7Gb1E";
export var sliderWrapper = "HorizontalScrollSection-module--sliderWrapper--85Fb8";
export var sliderContent = "HorizontalScrollSection-module--sliderContent--kzr70";
export var card = "HorizontalScrollSection-module--card--aBxQP";